module.exports = __webpack_public_path__ + "img/img_about_solution02.78ae64bb.png";